import { getAugmentedNamespace } from './_commonjsHelpers.js';
import * as index from '../node_modules/date-fns/esm/isSameDay/index.js';

var require$$49 = /*@__PURE__*/getAugmentedNamespace(index);

export { require$$49 as default };
